import { render } from "./BaseDialogFullscreen.vue?vue&type=template&id=197e79d5&scoped=true"
import script from "./BaseDialogFullscreen.vue?vue&type=script&lang=js"
export * from "./BaseDialogFullscreen.vue?vue&type=script&lang=js"

import "./BaseDialogFullscreen.vue?vue&type=style&index=0&id=197e79d5&scoped=true&lang=css"
import "./BaseDialogFullscreen.vue?vue&type=style&index=1&id=197e79d5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197e79d5"]])

export default __exports__